import app from 'flarum/app';

export default function () {
    app.route.formulaireFormShow = form => {
        return app.route('formulaireFormShow', {
            id: form.seoId(),
        });
    };

    app.route.formulaireFormEdit = form => {
        return app.route('formulaireFormEdit', {
            id: form.id(),
        });
    };

    app.route.formulaireSubmissionIndex = form => {
        return app.route('formulaireSubmissionIndex', {
            id: form.id(),
        });
    };

    app.route.formulaireSubmission = submission => {
        // TODO: switch with discussion or user profile for linked forms
        return app.route('formulaireSubmission', {
            id: submission.id(),
        });
    };

    app.route.formulaireProfile = (user, form) => {
        return app.route('formulaireProfile', {
            username: user.username(),
            form: form.seoId(),
        });
    };
}
